import { Button, Modal, ModalProps } from '@payaca/ambrosia';
import * as lineItemActions from '@payaca/store/lineItems/lineItemsActions';
import { singularPlural } from '@payaca/utilities/stringUtilities';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ListedLineItem } from '../../components/listedLineItemsTable/ListedLineItemsTable';

type Props = {
  onDeleteCallback?: () => void;
  selectedLineItems: ListedLineItem[];
} & Omit<ModalProps, 'title'>;
const ConfirmDeleteLineItemsModal = (props: Props) => {
  const { isOpen, onClose, onDeleteCallback, selectedLineItems } = props;
  const dispatch = useDispatch();

  const [isDeletingLineItems, setIsDeletingLineItems] =
    useState<boolean>(false);

  const onBulkDeleteItems = useCallback(
    (lineItems: ListedLineItem[]) => {
      setIsDeletingLineItems(true);
      const lineItemIds = lineItems.map((li) => +li.id);
      dispatch(
        lineItemActions.requestDeleteLineItems(lineItemIds, () => {
          onDeleteCallback?.();
          setIsDeletingLineItems(false);
        })
      );
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useCallback has a missing dependency: 'dispatch'
    [onDeleteCallback]
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Delete ${singularPlural(
        selectedLineItems.length,
        'item',
        'items'
      )} you sell`}
    >
      <Modal.Body>
        <p>
          Are you sure you want to delete{' '}
          {singularPlural(selectedLineItems.length, 'item', 'items')}?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            onClick={() => {
              if (!isDeletingLineItems) {
                onBulkDeleteItems(selectedLineItems);
              }
            }}
            isProcessing={isDeletingLineItems}
            colour="negative"
          >
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteLineItemsModal;
